<template>
  <v-card class="shadow half-radius">
    <v-container class="py-0">
      <v-row>
        <v-col cols="12">
          <v-row align="center" justify="end" class="pr-8">
            <v-avatar class="shadow circle ml-3">
              <v-img height="30" contain src="@/assets/logo.png" alt="Arches Dev"></v-img>
            </v-avatar>
            <span class="body-1 mx-6">Answer Key</span>
            <v-btn icon x-large @click="showAnswers = !showAnswers">
              <v-icon
                class="custom-icon"
                size="42"
                v-text="showAnswers ? '$vuetify.icons.appVisible' : '$vuetify.icons.appInvisible'"
              ></v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row
            :class="!$vuetify.breakpoint.xs ? 'px-10' : ''"
            :justify="!$vuetify.breakpoint.xs ? 'space-around' : 'start'"
          >
            <v-simple-table style="width: 100%">
              <template #default>
                <thead>
                  <tr>
                    <th class="text-center text--primary">Word</th>
                    <th class="text-center text--primary">A</th>
                    <th class="text-center text--primary">B</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(question, index) in answers" :key="'Word' + index">
                    <td>
                      {{ JSON.parse(questions[index].content).word }}
                    </td>
                    <td>
                      <div
                        class="custom-div px-1 text-truncate"
                        v-ripple
                        @click="finished ? '' : select('A', index)"
                      >
                        <p class="custom-text mb-0">
                          <v-icon color="#29284C" size="20">{{
                            answers[index].content === "A"
                              ? "mdi-radiobox-marked"
                              : "mdi-radiobox-blank"
                          }}</v-icon>
                          <span
                            class="px-1 custom-span ml-2"
                            :class="{
                              'red-border':
                                showAnswers && finished && questions[index].good_answer === 'A',
                            }"
                            >{{ JSON.parse(questions[index].content).A }}</span
                          >
                        </p>
                      </div>
                    </td>
                    <td>
                      <div
                        class="custom-div px-1 text-truncate"
                        v-ripple
                        @click="finished ? '' : select('B', index)"
                      >
                        <p class="custom-text mb-0">
                          <v-icon color="#29284C" size="20">{{
                            answers[index].content === "B"
                              ? "mdi-radiobox-marked"
                              : "mdi-radiobox-blank"
                          }}</v-icon>
                          <span
                            class="px-1 custom-span ml-2"
                            :class="{
                              'red-border':
                                showAnswers && finished && questions[index].good_answer === 'B',
                            }"
                            >{{ JSON.parse(questions[index].content).B }}</span
                          >
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-col>
        <v-col class="text-center mt-6 mb-8">
          <v-btn
            v-if="!finished"
            small
            depressed
            :disabled="disabled || finished"
            width="100"
            :loading="loading"
            class="white--text text-capitalize"
            color="#29284c"
            @click="onFinish"
            >Finish</v-btn
          >
          <ProgressResetButton v-else :stepType="stepType" :stepUuid="stepUuid" @reset="onReset" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import studentMixin from "@/mixins/studentMixin";
import answerMixin from "@/mixins/answerMixin";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    ProgressResetButton,
  },
  props: {
    stepUuid: {
      required: true,
      type: String,
    },
    questions: {
      required: true,
      type: Array,
    },
  },
  mixins: [studentMixin, answerMixin],
  data() {
    return {
      showAnswers: false,
    };
  },
  computed: {
    disabled() {
      for (let index = 0; index < this.answers.length; index++) {
        const element = this.answers[index];
        if (element.content === "") {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    select(letter, index) {
      if (!this.finished) {
        let item = { ...this.answers[index] };
        item.content = letter;
        this.answers.splice(index, 1, item);
      }
    },
  },
};
</script>
<style scoped>
.semi-title {
  font-weight: bold;
  font-size: 1.125rem;
}
.custom-icon {
  width: 42px !important;
}
.custom-divider {
  border-color: #707070;
}
.custom-div {
  padding-top: 2px;
  padding-bottom: 2px;
  margin-bottom: 8px;
}
.custom-div:hover {
  cursor: pointer;
}
.minus-margin {
  margin-bottom: 6px;
}
.red-border {
  border: 1px solid #ff2e7b;
  border-radius: 20px;
}
.custom-par {
  margin-bottom: 13px;
}
.custom-span {
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
